/* global axios */
import ApiClient from './ApiClient';

const compactParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== '' && value != null)
  ).toString();

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  pipeline(params = {}) {
    const query = compactParams(params);
    return axios.get(`${this.url}/pipeline${query ? `?${query}` : ''}`);
  }

  pipelineConfiguration() {
    return axios.get(`${this.baseUrl()}/pipeline_configuration`);
  }

  updatePipelineConfiguration(stages) {
    return axios.patch(`${this.baseUrl()}/pipeline_configuration`, {
      pipeline_configuration: { stages },
    });
  }

  similar({ companyId, name }) {
    return axios.get(
      `${this.url}/similar?${compactParams({ company_id: companyId, name })}`
    );
  }

  move(id, { stageId, lostReasonId }) {
    return axios.patch(`${this.url}/${id}/move`, {
      stage_id: stageId,
      lost_reason_id: lostReasonId,
    });
  }

  reactivate(id) {
    return axios.patch(`${this.url}/${id}/reactivate`);
  }

  won(id) {
    return axios.patch(`${this.url}/${id}/won`);
  }

  lost(id, lostReasonId) {
    return axios.patch(`${this.url}/${id}/lost`, {
      lost_reason_id: lostReasonId,
    });
  }

  updateDeal(id, attributes) {
    return axios.patch(`${this.url}/${id}`, { deal: attributes });
  }

  createActivity(id, activity) {
    return axios.post(`${this.url}/${id}/activities`, { activity });
  }

  updateActivity(id, activityId, activity) {
    return axios.patch(`${this.url}/${id}/activities/${activityId}`, {
      activity,
    });
  }

  createCommercialFollowUp(id, commercialAction) {
    return axios.post(`${this.url}/${id}/commercial_actions/follow_up`, {
      commercial_action: commercialAction,
    });
  }

  completeCommercialAction(id, commercialAction) {
    return axios.post(`${this.url}/${id}/commercial_actions/complete`, {
      commercial_action: commercialAction,
    });
  }

  commercialMessageSuggestion(id, commercialAction) {
    return axios.get(
      `${this.url}/${id}/commercial_actions/message_suggestion`,
      {
        params: { commercial_action: commercialAction },
      }
    );
  }

  createComment(id, body) {
    return axios.post(`${this.url}/${id}/comments`, { comment: { body } });
  }

  createDocument(id, document, file) {
    const formData = new FormData();
    Object.entries(document).forEach(([key, value]) => {
      if (key === 'metadata') {
        Object.entries(value).forEach(([metadataKey, metadataValue]) => {
          formData.append(`document[metadata][${metadataKey}]`, metadataValue);
        });
      } else if (value !== '' && value != null) {
        formData.append(`document[${key}]`, value);
      }
    });
    if (file) formData.append('file', file);
    return axios.post(`${this.url}/${id}/documents`, formData);
  }
}

export default new DealsAPI();
